export default __webpack_public_path__ + "static/media/cardioa.5a323cd0.svg";